(function () {
  function fixUnavailable(root) {
    var fieldsets = root.querySelectorAll('fieldset.swatch, fieldset.product-form__input');
    if (fieldsets.length < 2) return;

    for (var i = 0; i < fieldsets.length; i++) {
      var inputs = fieldsets[i].querySelectorAll('.swatch-input');
      if (!inputs.length) continue;

      var checked = null, firstAvailable = null;
      inputs.forEach(function (inp) {
        if (inp.checked) checked = inp;
        if (!firstAvailable && !inp.classList.contains('disabled') && !inp.disabled) firstAvailable = inp;
      });

      // current choice is unavailable, and something else is
      if (checked && (checked.classList.contains('disabled') || checked.disabled) && firstAvailable && firstAvailable !== checked) {
        firstAvailable.click();
        return; // the click fires another change event; let that pass run again
      }
    }
  }

  function bind(root) {
    var wrap = root.querySelector('variant-selects');
    if (!wrap || wrap.dataset.tmsFix) return;
    wrap.dataset.tmsFix = '1';
    wrap.addEventListener('change', function () {
      setTimeout(function () { fixUnavailable(wrap); }, 80);
    });
    setTimeout(function () { fixUnavailable(wrap); }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();